import VueSlickCarousel from 'vue-slick-carousel'
import Loader from '../../../assets/icons/loader.svg'
import { Slider, SliderItem } from '../components/slider'
import Benefit from '../components/Benefit.vue'

import { getJobs } from '../api/jobs'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'Jobs',
  components: {
    Loader,
    Slider,
    SliderItem,
    Benefit,
    VueSlickCarousel,
  },
  props: {
    postid: {
      type: Number,
      default: -1,
    },
    countryFilter: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      loading: true,
      jobs: null,
      // eslint-disable-next-line prefer-template
      url: argus_url.site + '/job/',
      benefit: null,
      sliderOptions: {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 0,
      },
    }
  },
  mounted() {
    psJobWidget.init()

    this.sliderOptions.slidesToShow = parseInt(this.$refs.certificates.dataset.certificates);

    this.loading = true

    getJobs(this.countryFilter)
      .then(res => {
        this.jobs = res.data.categories.reduce(
          (departs, curDepart) => ({ [curDepart.name]: { jobs: curDepart.jobs }, ...departs }),
          {}
        )
      })
      .catch(e => {
        console.log('Jobs API Error!', e)
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getJobsbyDepart(department) {
      const depart = this.jobs[department]

      if (depart) {
        return depart.jobs
      }

      return null
    },
  },
}
